var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { assertEx } from '@xyo-network/sdk-xyo-js';
import { createPaymentToken, createTransaction } from '../../apis';
import { RebillyPaymentMethod } from '../../rebilly';
export const expiryMonth = (expiry) => {
    return parseInt(expiry.split('/')[0]);
};
export const expiryYear = (expiry) => {
    return parseInt(expiry.split('/')[1]);
};
const createPaymentTokenParams = (params) => {
    var _a, _b, _c, _d, _e;
    return {
        billingAddress: Object.assign({ firstName: (_a = params.customer) === null || _a === void 0 ? void 0 : _a.firstName, lastName: (_b = params.customer) === null || _b === void 0 ? void 0 : _b.lastName }, params.billing),
        method: RebillyPaymentMethod.card,
        paymentInstrument: {
            cvv: assertEx(params.paymentInfo.cvc, 'Missing cvc'),
            expMonth: expiryMonth((_c = params.paymentInfo.expiry) !== null && _c !== void 0 ? _c : ''),
            expYear: expiryYear((_d = params.paymentInfo.expiry) !== null && _d !== void 0 ? _d : ''),
            pan: (_e = params.paymentInfo.creditcard) !== null && _e !== void 0 ? _e : '',
        },
        sandbox: params.sandbox,
    };
};
const processPayment = (params) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    let result = {};
    const { log } = params;
    console.log(`processPayment: ${JSON.stringify(params)}`);
    assertEx(((_b = (_a = params.cartInfo.items) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0, 'Missing Items');
    try {
        const paymentToken = yield createPaymentToken(createPaymentTokenParams(params));
        const items = [];
        const coupons = [];
        const discountCode = (_c = params.cartInfo.discountCode) === null || _c === void 0 ? void 0 : _c.code;
        if (discountCode) {
            coupons.push({ couponId: discountCode });
        }
        //only pass needed params
        for (const item of (_d = params.cartInfo.items) !== null && _d !== void 0 ? _d : []) {
            items.push({
                planId: item.planId,
                quantity: item.quantity,
            });
        }
        const payload = {
            billing: params.billing,
            coupons,
            customFields: (_e = params.customFields) !== null && _e !== void 0 ? _e : {},
            customer: (_f = params.customer) !== null && _f !== void 0 ? _f : {},
            items: items !== null && items !== void 0 ? items : {},
            paymentToken,
            sandbox: params.sandbox,
            shipping: params.shipping,
        };
        if (paymentToken) {
            console.log(`CT: ${JSON.stringify(payload)}`);
            result = yield createTransaction(payload);
            if (result.errors) {
                for (const error of result.errors) {
                    log === null || log === void 0 ? void 0 : log.warn('createTransaction', error);
                }
                log === null || log === void 0 ? void 0 : log.warn('processPayment Failed');
            }
        }
        else {
            throw new Error('Failed to create Payment Token');
        }
    }
    catch (e) {
        log === null || log === void 0 ? void 0 : log.error('processPayment', e.message || e);
        result = { errors: [e.message || e] };
        throw e;
    }
    return result;
});
export default processPayment;
